<div class="d-md-flex align-items-center bg-white p-2">
  <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{title}}:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{Totale ?? Materiali?.length ??
      0}}</span>
  </span>
  <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Valore Economico Magazzino:</h5>
    <span class=" px-3 font-weight-bold font-14">{{ValoreMagazzino | number: '2.2-2'}} €</span>
  </span>
  <div class="ml-auto mt-3 mt-md-0">
    <button type="button" (click)="edit()" class="btn btn-cyan  p-2"><i
        class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
    <button type="button" (click)="Ordina()"
      *ngIf="environment['MaterialiAddOn'] && environment['MaterialiAddOn']['Ordine']" class="btn btn-warning  p-2"><i
        class="fas fa-cart-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Crea nuovo Ordine</span>
    </button>
    <!--    <button type="button" (click)="Stampa()" class="btn btn-success  p-2" ><i class="fas fa-print  font-14 mr-1 text-white"></i>-->
    <!--      <span class="ml-1 text-white font-weight-bold">Stampa</span>-->
    <!--    </button>-->
  </div>
</div>
<!--Cerca "parte"-->
<div class="card">

  <div class=" d-flex align-items-center">
    <div class="form-group" style="min-width: 20rem; margin-inline: 1rem; margin-block: 0.4rem;">
      <ng-multiselect-dropdown [settings]="filtroFornitoriDropdownSettings"
        [placeholder]="'acquisti.cliente' | translate" id="fornitore" [data]="Fornitori" [(ngModel)]="FornitoriFiltro">
      </ng-multiselect-dropdown>
    </div>
    <div style="min-width: 7.5rem; margin-inline: 1rem; margin-block: 0.4rem; display: flex;">
      <label for="checkbox">Sotto Scorta:</label> &nbsp;
      <input id="checkbox" [(ngModel)]="filtri.sottoScorta" class="" type="checkbox">
    </div>
    <div class="form-group" style="min-width: 20rem; margin-inline: 1rem; margin-block: 0.4rem;">
      <input id="cerca" [(ngModel)]="filtri.parte" placeholder="Cerca" class="form-control" type="text">
    </div>
    <button type="button" class="btn btn-info rounded-pill py-2" (click)='Refresh(1)'>
      <i class="fas fa-search font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Cerca</span>
    </button>
  </div>
</div>
<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination [(page)]="SelectedPage" (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="Totale?? Materiali?.length ?? 0" [pageSize]="pageSize"></ngb-pagination>
</div>
<div class="table-responsive" style="    max-height: 60vh;">
  <table class="table bg-white table-hover align-middle mb-0">
    <thead>
      <tr>
        <th scope="col">
          <input type="checkbox" [(ngModel)]="SelectAll" name="list_name" value="h1" (change)="checkUncheckAll()" />
        </th>
        <th scope="col">Prodotto</th>
        <th scope="col">Prezzo</th>
        <th scope="col">ID_Articolo Produttore</th>
        <th scope="col">Magazzino</th>
        <th scope="col">Scorta Minima</th>
        <th scope="col">Ordinati</th>
        <th scope="col">Impegnati</th>
        <th scope="col" *ngIf="environment['MaterialiAddOn'] && environment['MaterialiAddOn']['Ordine']">Fornitore</th>
        <th scope="col" *ngIf="environment['MaterialiAddOn'] && environment['MaterialiAddOn']['Ordine']">Quantita da ordinare</th>
        <th scope="col">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let materiale of Materiali | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td class="align-middle">
          <input type="checkbox" [(ngModel)]="materiale.isSelected" name="list_name" (change)="ToggleItem(materiale)" />
        </td>
        <td (click)='edit(materiale)'>
          <span class="text-dark font-medium font-16">
            {{ materiale.nome}}
          </span>
        </td>
        <td class="align-middle " (click)='edit(materiale)'>
          <span>

            {{ materiale.prezzo}} €
          </span>
        </td>
        <td class="align-middle " (click)='edit(materiale)'>
          <span>
            {{ materiale.codice_produttore}}
          </span>
        </td>
        <td class="align-middle "
          [style.background-color]="(materiale.magazzino <= (materiale.scortaMin ?? 0))? 'red' :'none'"
          (click)='edit(materiale)'>
          <span>

            {{ materiale.magazzino}}
          </span>
        </td>
        <td class="align-middle " (click)='edit(materiale)'>
          <span>
            {{ materiale.scortaMin}}
          </span>
        </td>
        <td class="align-middle " (click)='edit(materiale)'>
          <span>
            {{ materiale.acquistati}}
          </span>
        </td>
        <td class="align-middle " (click)='edit(materiale)'>
          <span>
            {{ materiale.ordinati}}
          </span>
        </td>

        <td class="align-middle " *ngIf="environment['MaterialiAddOn'] && environment['MaterialiAddOn']['Ordine']">
          <span>
            <div class="form-group">
              <ng-multiselect-dropdown [settings]="clientiDropdownSettings" [placeholder]="'Fornitore' | translate"
                id="fornitore" [data]="Fornitori" [(ngModel)]="materiale.fornitoreObject"
                (ngModelChange)="FornitoreChange($event, materiale)">
              </ng-multiselect-dropdown>
            </div>
          </span>
        </td>
        <td class="align-middle " *ngIf="environment['MaterialiAddOn'] && environment['MaterialiAddOn']['Ordine']">
          <span>
            <input [(ngModel)]="materiale.quantita" placeholder="Quantità" type="number" min="0" name="iva"
              (ngModelChange)="QuantitaChange(materiale)" class="form-control">
          </span>
        </td>
        <td class="align-middle">
          <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2"  [ngbTooltip]="'Apri'" (click)='edit(materiale)'>
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a href="javascript:void(0)" class="link font-16 text-orange font-medium mr-2" [ngbTooltip]="'Apri in una nuova tab'" (click)='edit(materiale, true)'>
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='duplica(materiale)'>
            <i class="fas fa-copy"></i>
          </a>
          <a *ngIf="materiale.enabled" href="javascript:void(0)" class="link text-danger font-16 font-weight-bold"
            (click)='delete(materiale)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <!--        <a *ngIf="!materiale.enabled" href="javascript:void(0)" class="link text-orange font-16 font-weight-bold" (click)='renew(co)'>-->
          <!--          <i-feather name="plus" class="feather-sm"></i-feather>-->
          <!--        </a>-->
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination [(page)]="SelectedPage" (pageChange)="getPage($event)" id="paginationComponent2" [maxSize]="10"
    [collectionSize]="Totale?? Materiali?.length ?? 0" [pageSize]="pageSize"></ngb-pagination>
</div>